/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react';
import {
  string as stringType,
  func,
  bool as boolType
} from 'prop-types';
import {
  extend,
  string,
  QueryProvider,
  QueryContext,
  params,
  useDataModel
} from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { useStore, ExperienceContext } from '@thd-nucleus/experience-context';
import { dynamicRecsDataModel } from '../dataModel';
import { getCustomerType, getAppId, getCurrentDate, isAppliance } from '../utils/helpers';
import { VerticalRecsPodPlaceholder } from './VerticalRecsPodPlaceholder';
import { VerticalRecsDrawer } from './VerticalRecsDrawer';
import { VerticalRecsSubtitle } from './VerticalRecsSubtitle';
import { RECOMMENDATIONS } from '../core/constants';

const Wrapper = ({ children }) => children;
Wrapper.dataModel = extend({
  product: params({ itemId: string().isRequired() }).shape({
    dataSource: string(),
  })
}, VerticalRecsDrawer);

const VerticalRecs = (props) => {

  const { channel, customer, isConsumerApp } = useContext(ExperienceContext);
  const { defaultVariables } = useContext(QueryContext) || {};
  const isMobile = channel === 'mobile';
  const isB2BCustomer = customer?.type === 'b2b';
  const {
    itemId,
    recsIframeFlag,
    apiName,
    maxResults,
    updateRecsATCButton
  } = props;

  const { storeId, storeZip: zipCode, isLocalized, membershipInformation } = useStore();
  const [timeStamp] = useState(getCurrentDate());

  const opts = {
    variables: {
      anchorId: itemId,
      storeId,
      zipCode: zipCode || '12345',
      apiName,
      cType: getCustomerType(),
      timeStamp,
      skipInstallServices: true,
      dataSource: apiName,
      loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership || null,
      appId: getAppId(channel, isConsumerApp),
      maxResults,
      key: '',
      nvalue: null,
      serviceType: null
    },
    skip: recsIframeFlag === true || !isLocalized,
    ssr: false
  };

  const { data, loading, error } = useDataModel('recs', opts);

  if (error) {
    return null;
  }

  const qtxDefaultVariables = {
    storeId,
    zipCode,
    installationServices: false,
    loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership || null,
    skipFavoriteCount: !!isB2BCustomer,
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  const { products, metadata } = data?.recs || {};

  const recsBrand = (brandName) => {
    return (brandName !== null) ? 'More from ' + brandName : 'More from This Brand';
  };

  let title = '';

  switch (apiName) {
  case 'atc':
    title = 'Suggested Items';
    break;
  case 'pipcollection':
    title = 'Make It Match';
    break;
  case 'battery_collection':
    title = metadata?.collectionName || 'More from This Collection';
    break;
  case 'brand_based_collection':
    title = products?.length > 0 ? recsBrand(products[0]?.product?.identifiers?.brandName) : '';
    break;
  default:
    title = '';
  }
  // New Relic: recommendations
  const triggerNewRelic = () => {
    window.top?.LIFE_CYCLE_EVENT_BUS?.trigger('new-relic', {
      actionName: 'atcRecommendationLoaded',
      actionObject: { apiName, anchorSku: itemId }
    });
  };

  if (products?.length > 0) {
    triggerNewRelic();
  }

  return (
    <>
      {loading && (<VerticalRecsPodPlaceholder placeholderLines={3} placeholderCount={isMobile ? 2 : 5} placeholderImageHeight={24} isVertical />)}
      {!loading && !error && products?.length > 0 && (
        <QueryProvider
          dataSource={apiName}
          cacheKey={`${apiName}-recommendations-carousel`}
          defaultVariables={qtxDefaultVariables}
        >
          <ImpressionProvider data={{
            id: RECOMMENDATIONS.IMPRESSION.ID[apiName],
            name: title.replaceAll(' ', ''),
            component: 'VerticalRecs',
            type: 'product',
            position: ''
          }}
          >
            <div data-type="container" id={apiName} data-component={`VerticalRecs-${apiName}`}>
              <div className="sui-grid-cols-12 sui-p-3">
                <Typography variant="h4">{title}</Typography>
              </div>
              <div className="sui-grid-cols-12 sui-mx-4 sui-pb-2">
                <VerticalRecsSubtitle
                  scheme={apiName}
                  metadata={metadata}
                />
              </div>
              {products.map((dynamicProduct, idx) => {
                const { product } = dynamicProduct;
                const { preferredPriceFlag } = product.pricing;
                const { productType } = product?.identifiers?.productType;
                return (
                  <Wrapper key={idx}>
                    <VerticalRecsDrawer
                      itemId={product?.itemId}
                      key={product?.itemId}
                      position={idx}
                      preferredPriceFlag={preferredPriceFlag}
                      updateRecsATCButton={updateRecsATCButton}
                      storeId={storeId}
                      productType={productType}
                      anchorProduct={itemId}
                      apiName={apiName}
                      strategy={dynamicProduct?.strategy}
                      parent="atc-drawer-recommendation"
                      isAppliance={isAppliance(product)}
                      channel={channel}
                    />
                  </Wrapper>
                );
              }
              )}
            </div>
          </ImpressionProvider>
        </QueryProvider>
      )}
    </>
  );
};

const dataModel = dynamicRecsDataModel;
VerticalRecs.dataModel = dataModel;
VerticalRecs.displayName = 'VerticalRecommendation';

VerticalRecs.propTypes = {
  itemId: stringType.isRequired,
  apiName: stringType.isRequired,
  recsIframeFlag: boolType,
  updateRecsATCButton: func
};

VerticalRecs.defaultProps = {
  recsIframeFlag: false,
  updateRecsATCButton: () => { }
};

export { VerticalRecs };
